<template>
  <div class="alliance container">
    <div class="columns">
      <div class="column is-12">
        <div class="header has-background-primary p-lg m-t-lg">
          <h1
            class="has-text-weight-bold has-text-centered has-text-white is-size-3"
          >
            ALIANZAS <span class="dropText">CASA ADMINISTRACIONES</span>
          </h1>
        </div>
      </div>
    </div>
    <div class="columns m-t-lg">
      <div class="column">
        <h2
          class="has-text-weight-bold has-text-centered is-size-3 m-b-lg m-t-lg"
        >
          ¡PRÓXIMAMENTE!
        </h2>
      </div>
      <!-- <div class="column is-5">
        <div class="box main-image is-shadowless">
          <figure>
            <img src="@/assets/images/hero_1.jpg" alt="alianza" />
          </figure>
          <div class="has-text-centered">
            <a
              href="https://google.com"
              target="_blank"
              class="button has-text-weight-bold has-text-link is-white"
            >
              Ver más
            </a>
          </div>
        </div>
      </div> 
      <div class="column is-7">
        <div class="box is-shadowless">
          <div class="columns">
            <div class="column is-6 secondary-logo is-relative">
              <figure>
                <img
                  src="@/assets/images/alianzas/bermeo_logosf.svg"
                  alt="logo Bermeo"
                />
              </figure>
              <div class="secondary-link">
                <a
                  href="https://caalianzas.com"
                  target="_blank"
                  class="button has-text-weight-bold has-text-link is-white"
                >
                  Ver más
                </a>
              </div>
            </div>
            <div class="column is-6 secondary-image">
              <figure>
                <img
                  src="@/assets/images/alianzas/bermeo_principal.jpg"
                  alt="alianza Bermeo"
                />
              </figure>
            </div>
          </div>
        </div>
        <-- <div class="box is-shadowless">
          <div class="columns">
            <div class="column is-6 secondary-logo is-relative">
              <figure>
                <img src="@/assets/images/logo.png" alt="logo" />
              </figure>
              <div class="secondary-link">
                <a
                  href="https://google.com"
                  target="_blank"
                  class="button has-text-weight-bold has-text-link is-white"
                >
                  Ver más
                </a>
              </div>
            </div>
            <div class="column is-6 secondary-image">
              <figure>
                <img src="@/assets/images/hero_1.jpg" alt="alianza" />
              </figure>
            </div>
          </div>
        </div> --
      </div>-->
    </div>
  </div>
</template>

<script>
//   import MainContact from "@/components/MainContact";

export default {
  name: "Alliances",

  components: {
    //   MainContact
  },

  metaInfo() {
    return {
      title: "Alianzas",
      titleTemplate: "%s - CasaAdministraciones",
      meta: [
        {
          name: "description",
          content: "Alianzas Casa Administraciones, Conoce nuestras alianzas"
        }
      ],
      link: [
        {
          rel: "canonical",
          href: window.location.origin + this.$router.currentRoute.path
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.dropText {
  display: block;
}

.box {
  background-color: #f9f9f9 !important;

  a {
    background-color: #f9f9f9;
  }

  .secondary-link {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    bottom: -25;
  }
}
.main-image img {
  max-height: 350px;
  width: 100%;
}

.secondary-image img {
  max-height: 150px;
  width: 100%;
  object-fit: cover;
}
@media only screen and (min-width: 769px) {
  .dropText {
    display: inline;
  }

  .secondary-link {
    bottom: 0;
  }
}
</style>
